import API from '../Services/API';
import Model from './Model';

const useWhatsNew = (alwaysRefresh = false) => {
    return Model({
        alwaysRefresh: alwaysRefresh,
        stateKey: 'whatsNew',
        fetchData: () => API.get('/whats-new'),
        returnDataKey: 'whatsNew',
        defaultLoadingError: 'Sorry, there was an error loading recent updates.',
        registerAdditionalMethods: (opts) => {
            return {
                giveFeedback: (id, feedback) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/whats-new/${id}/feedback`, {feedback}),
                        'Feedback was saved',
                        true,
                    );
                },
            }
        }
    });
}

export {
    useWhatsNew,
}
